import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.form = this.element.querySelector('form');
    this.incluirImporteSwitch = this.form.querySelector('#incluirImporteSwitch');
    this.importeInput = this.form.querySelector('#autorizacion_importe');

    if (this.incluirImporteSwitch) {
      this.incluirImporteSwitch.addEventListener('change', () => this.onIncluirImporteSwitch());
    }
  }

  onIncluirImporteSwitch() {
    if (this.incluirImporteSwitch.checked) {
      this.importeInput.disabled = '';
    } else {
      this.importeInput.disabled = 'disabled';
    }
  }
}
